import router from '../router'
import userService from '../service/user'
import { Message } from 'element-ui'
import Axios from 'axios';
import queryStringUtil from "query-string";

let domain = window.location.host
if (process.env.NODE_ENV != 'production') {
    if (process.env.VUE_APP_CUSTOMER) {
        domain = process.env.VUE_APP_CUSTOMER
    } else {
        domain = 'localhost'
    }
}
let user = ''
try {
    user = JSON.parse(localStorage.getItem('user'));
} catch (e) {
    console.log(e)
}
const state = user
    ? {
        status: {
            loggedIn: true
        },
        reCaptchaCount: 0,
        user,
        customer: '',
        activeTab: "dashboard",
        pointTabs: []

    }
    : {
        status: {},
        reCaptchaCount: 0,
        user: null,
        customer: '',
        activeTab: 'dashboard',
        pointTabs: []
    };


const actions = {
   
    removePointTab({ commit }, tab) {
        commit('removePointTab', tab)
    },
    changePointTab({ commit }, tab) {
        commit('changePointTab', tab)
    },
    changeTab({ commit }, tab) {
        commit('setTab', tab)
    },
    loadCustomer({ commit }) {
        return userService.getCustomer(domain).then(customer => {
            localStorage.setItem('preferences', JSON.stringify(customer.preferences));
            commit('setCustomer', customer)
        }).catch(e => {
            console.log(e)
            return userService.getCustomerSummary(domain).then(customer => {
                localStorage.setItem('preferences', JSON.stringify(customer.preferences));
                commit('setCustomer', customer)
            })
        })

    },

    finishUserGuiding({ commit }) {
        return userService.updateUserGuidingShown(true).then(() => {
            commit('setUserGuiding', true)
        });
    },

    verifyMFA({ dispatch, commit }, { trnxId, code, reCaptcha }) {
        return userService.verifyMFA( trnxId, code, reCaptcha)
        .then(user => {
          
                commit('loginSuccess', user);
                dispatch('deviceConfigurations/getDeviceConfigurations', null, { root: true })
                dispatch('point/getPoints', [], { root: true })
                dispatch('account/loadCustomer', '', { root: true })
                let urlParams = queryStringUtil.parse(window.location.search)

                if (urlParams.returnUrl === undefined) {
                    router.push(`/`);
                } else {
                    router.push(`${urlParams.returnUrl}`);
                }
           
        }).catch((error) => {
            if (!Axios.isCancel()) {
                console.log(error)
                Message.error(error.response.data.message)
            } else {
                throw error
            }
        })
    },
    login({ dispatch, commit }, { email, password, reCaptcha }) {
        commit('loginRequest', { email });

        return userService.auth(domain, email, password, reCaptcha)
            .then(user => {
                if(user.requireMFAVerification){
                    commit('setMFAResponse', user);
                    router.push(`/verify-mfa/${user.mfa_id}`).catch(e=>{
                        console.log(e)
                    });
                    return;
                }else{
                    commit('loginSuccess', user);
                    dispatch('deviceConfigurations/getDeviceConfigurations', null, { root: true })
                    dispatch('point/getPoints', [], { root: true })
                    dispatch('account/loadCustomer', '', { root: true })
                    let urlParams = queryStringUtil.parse(window.location.search)
    
                    if (urlParams.returnUrl === undefined) {
                        router.push(`/`);
                    } else {
                        router.push(`${urlParams.returnUrl}`);
                    }
                }

               
            }).catch((error) => {
                commit('loginFailure', error.response.data.wrongPassword)
                if (!Axios.isCancel()) {
                    Message.error(error.response.data.message)
                } else {
                    throw error
                }
            })
    },
    logout({ commit }) {
        localStorage.removeItem('user')
        router.push('/login')
        commit('logout');
    },
};
const mutations = {
    setUserGuiding(state, boolean) {
        state.user.userGuidingShown = boolean
        var userData = JSON.parse(localStorage.getItem('user'))
        userData.userGuidingShown = boolean;
        localStorage.setItem('user', JSON.stringify(userData))
    },
    changePointTab(state, tab) {
        if (state.pointTabs.indexOf(tab) == -1) {
            state.pointTabs = [tab]
            state.activeTab = tab;
        }
    },
    removePointTab(state, tab) {
        let index = state.pointTabs.indexOf(tab);
        if (state.activeTab === tab) {
            state.activeTab = "dashboard";
        }
        if (index != -1) {
            state.pointTabs.splice(index, 1);
        }
    },
    setTab(state, tab) {
        state.activeTab = tab
    },
    setCustomer(state, customer) {
        state.customer = customer
    },
    setGateways(state, gateways) {
        state.gateways = gateways
    },
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    setMFAResponse(state, data) {
        state.reCaptchaCount = 0;
        state.status = { loggedIn: false };
        state.user = {
            mfa_id:data.mfa_id,
            permissions: data.permissions,
            passwordChanged:data.passwordChanged,
            userId: data.userId,
            name: data.name,
            surname: data.surname,
            role: data.role,
            userGuidingShown: data.userGuidingShown
        };
    },
    loginSuccess(state, data) {
        state.reCaptchaCount = 0;
        localStorage.setItem('user', JSON.stringify(data))
        state.status = { loggedIn: true };
        state.user = {
            permissions: data.permissions,
            passwordChanged:data.passwordChanged,
            userId: data.userId,
            name: data.name,
            surname: data.surname,
            role: data.role,
            userGuidingShown: data.userGuidingShown
        };
    },
    loginFailure(state, wrongPassword) {
        state.reCaptchaCount = wrongPassword ? wrongPassword : state.reCaptchaCount++;
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    
};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
